import { useMemo, useState } from "react";
import translate from "../locales";
import logo from "../assets/logo.png";
import { Statement } from "./statement";
import { StartPage } from "./start";
import { Result } from "./result";

export function Session({ questionSet }) {
  const [answers, setAnswers] = useState({});
  const [currentIndex, setCurrentIndex] = useState(-1);
  const currentStatement = useMemo(
    () => questionSet.statements[currentIndex],
    [currentIndex],
  );
  const statementsCount = questionSet.statements.length;

  function handleAnswer(id, value) {
    setAnswers((answers) => ({ ...answers, [id]: value }));
    setCurrentIndex((v) => v + 1);
  }

  function restart() {
    setAnswers({});
    setCurrentIndex(-1);
  }

  return (
    <>
      <header className="header">
        <img
          src={logo}
          alt={translate("general.logoAlt")}
          className="header__logo"
        />
      </header>
      {currentIndex === -1 && (
        <StartPage
          statementCount={questionSet.statements.length}
          onStart={() => setCurrentIndex(0)}
        />
      )}
      {currentStatement && (
        <>
          <Statement
            index={currentIndex}
            statement={currentStatement}
            onAnswer={handleAnswer}
            key={currentStatement._id}
          />
          <footer className="footer">
            <span className="footer__progress">
              <span className="footer__progress-current">
                {currentIndex + 1}
              </span>
              &nbsp;/&nbsp;{statementsCount}
            </span>
          </footer>
        </>
      )}
      {currentIndex === statementsCount && (
        <Result
          answers={answers}
          questionSet={questionSet}
          onRestart={restart}
        />
      )}
    </>
  );
}
